// My Account
import './account-page';
import { Constants } from "../js/ENVIROMENT_VARIABLES";
import "jquery/dist/jquery.min";
import "jquery-validation/dist/jquery.validate.min";
import "jquery-validation/dist/additional-methods.min";

var TPP_Token = JSON.parse(sessionStorage.getItem('TPP_Token'));
var TP_Token = JSON.parse(sessionStorage.getItem('TP_Token'));
var IsAuthenticated=TPP_Token ? true :false ;
var appointmentData={}
var selectedName ;
var selectedValue ;
var selectedBranchValue;


const appoitment_form= $("#appoitment_form");
appoitment_form.validate({
  errorClass: "invalid",
  validClass: "valid",
  // errorElement: "em",
  rules: {
    users: {
      required: true,
     
    },
    branches: {
      required: true,
     
    }
  },
  onfocusout: function (element) {
    this.element(element); // triggers validation
  },
  onkeyup: function (element, event) {
    this.element(element); // triggers validation
  },
  messages: {
    users: {
      required: "Select User please",
    },
    branches: {
      required: "Select Branch please",
    }
  },
  errorElement: "em",
  errorPlacement: function (error, element) {
    // Add the `help-block` class to the error element
    error.addClass("alert alert-danger d-flex align-items-center mt-2");

    // Add `has-feedback` class to the parent div.form-group
    // in order to add icons to inputs
    element.parents(".input-field").addClass("is-invalid");

    if (element.prop("type") === "checkbox") {
      error.insertAfter(element.parent("label"));
    } else {
      error.insertAfter(element);
    }
  },
  success: function (label, element) {
    //hide error alert
    $(element).addClass("is-valid").removeClass("-invalid");
    $(element)
      .siblings("em")
      .removeClass("alert alert-danger d-flex align-items-center mt-2");
  },
  highlight: function (element, errorClass, validClass) {
    $(element).addClass("is-invalid").removeClass("is-valid");
    // $( element ).next( "span" ).addClass( "is-valid" ).removeClass( "is-invalid" );
    $(element)
      .siblings("em")
      .addClass("alert alert-danger d-flex align-items-center mt-2");
  },
  unhighlight: function (element, errorClass, validClass) {
    $(element).addClass("is-valid").removeClass("is-invalid");
    $(element)
      .siblings("em")
      .removeClass("alert alert-danger d-flex align-items-center mt-2");
  },
  submitHandler: function (login_form) {
    getAppoitments();
    console.log(appointmentData)

     

      
  },
});

// $.validator.addMethod("notDefault", function(value, element, param) {
//     return value !== param;
//   }, "Please select an option.");

//   $.validator.addMethod("isTouched", function(value, element) {
//     return $(element).data("touched");
//   }, "Please select an option.");

// Get the submit button element
// var submitButton = $("#get_tests");

// // Add an event listener to the form's inputs
// appoitment_form.on("input", "input, select", function() {
//   // Check if the form is valid
//   if (appoitment_form.valid()) {
//     submitButton.prop("disabled", false); // Enable the submit button
//   } else {
//     submitButton.prop("disabled", true); // Disable the submit button
//   }
// });

getProfile();
getBranches();
function getProfile(){
    $("#loading-overlay").show();
    $.ajax({
        type: "POST",
        url:`${Constants.BASE_URL}thirdParty/getPatients.srvc?method=POST`,
        headers: {
            'Accept': 'application/json',
            'Content-Type':'application/json',
            'Data-Type': 'json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': '*',
            'Access-Control-Allow-Headers': 'Content-Type , Authorization',
            'Access-Control-Allow-Credentials': 'true',
            'Authorization': `Bearer ${TPP_Token.Token}`
        },
        success:function (data){
            $("#loading-overlay").hide();
            for(let i=0; i<data.length; i++){
                if(data[i].isMobileOwner==true){
                    $('#profile_id').append(`
                    <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-between">
                            <h5 class="card-title name">${data[i].fullName.en_us}</h5>
                            <button data-MemberId=${data[i].rid} type="button" class="btn btn-link edit-profile-btn" data-bs-toggle="modal"
                            data-bs-target="#edit_profile_modal">
                            <i class="fas fa-pen"></i>
                            </button>
                        </div>
                       
                    </div>
                    <div class="d-flex">
                        <span class="type"><span>Gender</span>:&nbsp;</span>
                        <p class="card-text gender d-flex align-items-center m-0">${data[i].gender.name.en_us}</p>
                    </div>
                    <div class="d-flex">
                        <span class="type"><span>Address</span>:&nbsp;</span>
                        <p class="card-text user-address d-flex align-items-center m-0">${data[i].address.en_us}</p>
                    </div>
                    <div class="d-flex">
                        <span class="type"><span>Mobile Number</span>:&nbsp;</span>
                        <p class="card-text mobileNo phone d-flex align-items-center m-0">${data[i].mobileNo}</p>
                    </div>
                    <div class="d-flex">
                        <span class="type"><span>Email</span>:&nbsp;</span>
                        <p class="card-text email d-flex align-items-center m-0">${data[i].email}</p>
                    </div>
                    <div class="d-flex">
                        <span class="type"><span>National Id</span>:&nbsp;</span>
                        <p class="card-text nationalId d-flex align-items-center m-0">${data[i].nationalId}</p>
                    </div>
                    `);
                }
                else{
                    $('#family_members_cards').append(`
                      
                    <div class="col" data-MemberId=${data[i].rid}>
                      <div class="card h-100" id="member_2_profile">
                        <div class="text-container">
                          <div class="card-body">
                          <h5 class="card-title name">${data[i].fullName.en_us}</h5>
                            <div class="d-flex">
                                <span class="type"><span>Gender</span>:&nbsp;</span>
                                <p class="card-text gender d-flex align-items-center m-0">${data[i].gender.name.en_us}</p>
                            </div>
                            <div class="d-flex">
                                <span class="type"><span>Address</span>:&nbsp;</span>
                                <p class="card-text user-address d-flex align-items-center m-0">${data[i].address.en_us}</p>
                            </div>
                            <div class="d-flex">
                                <span class="type"><span>Mobile Number</span>:&nbsp;</span>
                                <p class="card-text phone d-flex align-items-center m-0">${data[i].mobileNo}</p>
                            </div>
                            <div class="d-flex">
                                <span class="type"><span>Email</span>:&nbsp;</span>
                                <p class="card-text email d-flex align-items-center m-0">${data[i].email}</p>
                            </div>
                            <div class="d-flex">
                                <span class="type"><span>National Id</span>:&nbsp;</span>
                                <p class="card-text nationalId d-flex align-items-center m-0">${data[i].nationalId}</p>
                            </div>
                          </div>
                        </div>
                        <button data-MemberId=${data[i].rid} type="button" class="btn btn-link edit-profile-btn" data-bs-toggle="modal"
                          data-bs-target="#edit_profile_modal">
                          <i class="fas fa-pen"></i>
                        </button>
                        <!-- <button data-MemberId=${data[i].rid} type="button" class="btn btn-link delete-profile-btn" data-bs-toggle="modal"
                          data-bs-target="#delete_profile_modal">
                          <i class="fas fa-trash"></i>
                        </button> -->
                      </div>
                    </div>
                    `)
                }

                $('#my-tests-user-select').append(`
                    <option value="${data[i].rid}" data-MemberId=${data[i].rid}>${data[i].fullName.en_us} </option>
                `);
                selectedValue = $('#my-tests-user-select').val();
                selectedName = $('#my-tests-user-select').find('option:selected').text();
                console.log(selectedName)
                appointmentData.patientId=selectedValue;


                
            }
            
        }
    });
  

}

function getBranches(){
    // API CALLING FOR BRANCH LIST
$.ajax({
    type: "POST",
    url:`${Constants.BASE_URL}thirdParty/getBranches.srvc?method=POST`,
    headers: {
        "Content-Type":"application/json",
         Accept: "application/json",
        'Data-Type': 'json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Headers': 'Content-Type , Authorization',
        'Access-Control-Allow-Credentials': 'true',
        'Authorization': `Bearer ${TP_Token.Token}`
    },
    success: function (data) {
    
      $("#loading-overlay").hide();
    
      for(let i=0; i<data.length; i++){
        $('#user-branch-select').append(`
            <option value="${data[i].rid}">${data[i].name.en_us}</option>
        `)
       }
        selectedBranchValue =$("#user-branch-select").val();
        appointmentData.branchId=selectedBranchValue;

    },
    
    });
}
function getAppoitments(){
    $("#loading-overlay").show();
    $.ajax({
        type: "POST",
        data:JSON.stringify(appointmentData),
        url:`${Constants.BASE_URL}thirdParty/getAppointmentData.srvc?method=POST`,
        headers: {
            'Accept': 'application/json',
            'Content-Type':'application/json',
            'Data-Type': 'json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': '*',
            'Access-Control-Allow-Headers': 'Content-Type , Authorization',
            'Access-Control-Allow-Credentials': 'true',
            'Authorization': `Bearer ${TPP_Token.Token}`
        },
        success:function (data){
            $("#loading-overlay").hide();
            if(data.length !=0){
                for(let i=0; i<data.length; i++){
                    if(data[i].appointmentStatus=='RESERVED'){
                    $('#completed-tests-content').append(`
                    <div class="card test-card px-5" data-appoitmentid="${data[i].rid}">
                    <div class="row g-0">
                        <div class="col-md-12">
                            <div class="card-body">
                                <div class="d-flex justify-content-between">
                                    <h5 class="card-title">${selectedName}</h5>
                                    <div class="d-flex align-items-center">
                                        <h5 class="price">null SAR</h5>
                                    
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end">
                                    <p class="order-details" data-bs-toggle="collapse" href="#detailsOrder_@Model.Id" role="button" aria-expanded="false" aria-controls="detailsOrder_@Model.Id" data-patientid="@Model.Id" data-i18n-key="order-details">
                                        Order Detalis
                                    </p>
                                    <p  class=" order-details cancel-order bg-danger text-white px-2 rounded-pill ms-2" data-bs-toggle="modal" data-bs-target="#delete_order_modal" id="cancell_order" data-i18n-key="cancel-order" data-appoitmentid=${data[i].rid}>
                                        Cancel Order
                                    </p>
                                </div>
                
                                <p class="branch-name" data-i18n-key="home-visit">Home Visit</p>
                                <hr class="my-tests-separator">
                                <!-- tables -->
                                <div class="row m-auto">
                                    <div class="col-sm-12 col-xl-6 p-0">
                                        <div class="table-responsive">
                                            <table class="table table-bModelless m-0">
                                                <tbody>
                                                    <tr>
                                                        <td class="col-md-1 td-head" data-i18n-key="patient-name">Patient Name</td>
                                                        <td class="col-md-2">${selectedName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-md-1 td-head" data-i18n-key="medical-id">Meidcal ID</td>
                                                        <td class="col-md-2 edit-order-id">${selectedValue}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-md-1 td-head" data-i18n-key="order-id">Order ID</td>
                                                        <td class="col-md-2">${data[i].rid}</td>
                                                    </tr>
                
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-xl-6 p-0">
                                        <div class="table-responsive">
                                            <table class="table table-bModelless m-0">
                                                <tbody>
                                                    <tr>
                                                        <td class="col-md-1 td-head" data-i18n-key="payment-type">Payment Type</td>
                                                        <td class="col-md-2" data-i18n-key="cash">Cash</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-md-1 td-head" data-i18n-key="test-date">Test Date</td>
                                                        <td class="col-md-2 edit-order-date">${data[i].reservedStartTime}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="col-md-1 td-head" data-i18n-key="test-status">Test Status</td>
                                                        <td class="col-md-2 test-status">${data[i].appointmentStatus}</td>
                                                    </tr>
                
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                        <div class="col-sm-12 col-xl-12 p-0">
                                            <div class="table-responsive">
                                                <table class="table table-bModelless m-0">
                                                    <tbody>
                                                        <tr>
                                                            <td class="col-md-1 td-head" data-i18n-key="patient-address">Patient Appointment Type</td>
                                                            <td class="col-md-5 edit-order-addresse">${data[i].appointmentType}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    `)
                    }
                    else{
                        $('#upcoming-tests-content').append(`
                        <div class="card test-card px-5" data-appoitmentid="${data[i].rid}">
                        <div class="row g-0">
                            <div class="col-md-12">
                                <div class="card-body">
                                    <div class="d-flex justify-content-between">
                                        <h5 class="card-title">${selectedName}</h5>
                                        <div class="d-flex align-items-center">
                                            <h5 class="price">null SAR</h5>
                                        
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end">
                                        <p class="order-details" data-bs-toggle="collapse" href="#detailsOrder_@Model.Id" role="button" aria-expanded="false" aria-controls="detailsOrder_@Model.Id" data-patientid="@Model.Id" data-i18n-key="order-details">
                                            Order Detalis
                                        </p>
                                        <p  class=" order-details cancel-order bg-danger text-white px-2 rounded-pill ms-2" data-appoitmentid=${data[i].rid}  data-bs-toggle="modal" data-bs-target="#delete_order_modal" id="cancell_order" data-i18n-key="cancel-order">
                                            Cancel Order
                                        </p>
                                    </div>
                    
                                    <p class="branch-name" data-i18n-key="home-visit">Home Visit</p>
                                    <hr class="my-tests-separator">
                                    <!-- tables -->
                                    <div class="row m-auto">
                                        <div class="col-sm-12 col-xl-6 p-0">
                                            <div class="table-responsive">
                                                <table class="table table-bModelless m-0">
                                                    <tbody>
                                                        <tr>
                                                            <td class="col-md-1 td-head" data-i18n-key="patient-name">Patient Name</td>
                                                            <td class="col-md-2">${selectedName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="col-md-1 td-head" data-i18n-key="medical-id">Meidcal ID</td>
                                                            <td class="col-md-2 edit-order-id">${selectedValue}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="col-md-1 td-head" data-i18n-key="order-id">Order ID</td>
                                                            <td class="col-md-2">${data[i].rid}</td>
                                                        </tr>
                    
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-xl-6 p-0">
                                            <div class="table-responsive">
                                                <table class="table table-bModelless m-0">
                                                    <tbody>
                                                        <tr>
                                                            <td class="col-md-1 td-head" data-i18n-key="payment-type">Payment Type</td>
                                                            <td class="col-md-2" data-i18n-key="cash">Cash</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="col-md-1 td-head" data-i18n-key="test-date">Test Date</td>
                                                            <td class="col-md-2 edit-order-date">${data[i].reservedStartTime}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="col-md-1 td-head" data-i18n-key="test-status">Test Status</td>
                                                            <td class="col-md-2 test-status">${data[i].appointmentStatus}</td>
                                                        </tr>
                    
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                            <div class="col-sm-12 col-xl-12 p-0">
                                                <div class="table-responsive">
                                                    <table class="table table-bModelless m-0">
                                                        <tbody>
                                                            <tr>
                                                                <td class="col-md-1 td-head" data-i18n-key="patient-address">Patient Appointment Type</td>
                                                                <td class="col-md-5 edit-order-addresse">${data[i].appointmentType}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        `)
                    }
                   
            
                }
            }
            else{
            $('#upcoming-tests-content').html(`
                <p class="test">No Tests Found</p>
            `)
            $('#completed-tests-content').html(`
                <p class="test">No Tests Found</p>
            `)
            }
            
            
            
    }
    });
}
$(document).ready(function() {

    $('#my-tests-user-select').on('change', function() {
      selectedValue = $(this).val();
     selectedName = $(this).find('option:selected').html();
      appointmentData.patientId=selectedValue;

    });
    $('#user-branch-select').on('change', function() {
    selectedBranchValue = $(this).val();
      appointmentData.branchId=selectedBranchValue;

    });
  });
//   $(document).on("click", "#get_tests", function(event) {
    
//     console.log(appointmentData)
//     if(appointmentData=null){
       
//         console.log(selectedValue)

//         $('#upcoming-tests-content').html(
//          `<p>PLease Select Family Member and Branch</p>`
//         );
//     }
//     else{

//         getAppoitments();

//     }


//   })
// update user info
$(document).on("click", ".edit-profile-btn", function(event) {
    const memberId = $(this).data("memberid");
    console.log(memberId);

    const index = $(".edit-profile-btn").index(this);
    const memberAddress = $(".user-address").eq(index).text();
    const memberPhone = $(".phone").eq(index).text();
    const memberEmail = $(".email").eq(index).text();
    const memberName = $(".name").eq(index).text();
    const memberNationalId = $(".nationalId").eq(index).text();
    const profileGender = $(".gender").eq(index).text();

    $("#profile_address").val(memberAddress);
    $("#profile_phone").val(memberPhone);
    $("#profile_email").val(memberEmail);
    $("#profile_name").val(memberName);
    $("#profile_nationalId").val(memberNationalId);

    if (profileGender === 'Male') {
        $("input[name='gender-radio'][value='male']").prop("checked", true);
    } else {
        $("input[name='gender-radio'][value='female']").prop("checked", true);
    }

    $(document).on("click", "#update-profile", function(event) {
    var names= ($("#profile_name").val()).split(" ");
    const updateData={
        address:{
            "en_us": $("#profile_address").val()
        },
        email: $("#profile_email").val(),
        firstName:{
            "en_us":names[0]
        },
        secondName:{
            "en_us":names[1]
        },
        thirdName:{
            "en_us":names[2]
        },
        lastName:{
            "en_us":names[3]
        },
        nationalId: $("#profile_nationalId").val(),
        rid:memberId
    }
        console.log(
            updateData
        );
        $.ajax({
            type: "POST",
            data:JSON.stringify(updateData),
            url:`${Constants.BASE_URL}thirdParty/updatePatient.srvc?method=POST`,
            headers: {
                'Accept': 'application/json',
                'Content-Type':'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Access-Control-Allow-Headers': 'Content-Type , Authorization',
                'Access-Control-Allow-Credentials': 'true',
                'Authorization': `Bearer ${TPP_Token.Token}`
            },

            success:function (data){
                $("#loading-overlay").hide();
                $("#edit_profile_modal").hide();
                location.reload();
             }
        });
    });

});
// delete user info
$(document).on("click", ".delete-profile-btn", function(event) {
    const memberId = $(this).data("memberid");
    const index = $(".delete-profile-btn").index(this);
    const memberName = $(".name").eq(index+1).text();
    console.log(memberId);
    $("#waring-member").text(`Delete ${memberName}`)
});
// cancel appoitment
$(document).on("click", ".cancel-order", function(event) {
    const orderId = $(this).data("appoitmentid");
    console.log(orderId);
    $("#loading-overlay").show();
    $.ajax({
        type: "POST",
        data:JSON.stringify({
            "appointmentId": orderId
        }),
        url:`${Constants.BASE_URL}thirdParty/cancelAppointment.srvc?method=POST`,
        headers: {
            'Accept': 'application/json',
            'Content-Type':'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': '*',
            'Access-Control-Allow-Headers': 'Content-Type , Authorization',
            'Access-Control-Allow-Credentials': 'true',
            'Authorization': `Bearer ${TPP_Token.Token}`
        },

        success:function (data){
            $("#loading-overlay").hide();
         }
    });
  
});


// Hide cancel order status in completet app
document.getElementById("completed-tests-tab").onclick=function(){   
    //  document.getElementById("cancell_order").style.display="none";
     $("#completed-tests-content #cancell_order").hide();
}




